import * as React from 'react';
import Styled, { css } from 'styled-components';

import { media } from '../../../lib/StyledComponents';
import { ActionButton } from '../../ActionButton';
import { Label } from '../../Typography';
import { SVGIcon } from '../../Icon';

const ButtonLabel = Styled(Label)`
  color: unset;
  margin-bottom: -0.4em;
`;

export const MenuButtonStyles = Styled(ActionButton)`
  box-shadow: none; /* CSP header fix */
  border-color: transparent;

  &:hover,
  &:focus,
  &:active {
    border-color: transparent;
    background-color: transparent;
    color: ${({ theme: { brand }}) => brand.colorPrimarySoft};
  }

  ${ButtonLabel} {
    display: none;
  }

  ${({ theme: { actionButton } }) => css`
    border-color: ${actionButton.colorBorder};

    ${media.small`
      &:hover,
      &:focus {
        color: ${actionButton.colorTextHover};
        border-color: ${actionButton.colorBorderHover};
      }

      &:active {
        border-color: ${actionButton.colorBorderHover};
        background: ${actionButton.colorBackgroundActive};
        color: ${actionButton.colorTextActive};

        svg {
          fill: ${actionButton.colorTextActive};
        }
      }

      ${ButtonLabel} {
        display: block;
      }
    `}
  `}
`;

export const MenuIcon = Styled(SVGIcon)`
  svg {
    display: flex;
    width: 20px;
    height: 20px;
    margin: 0;
  }

  ${media.small`
    margin-left: 0.625em;
  `}
`;

interface IMenuControlProps {
  ariaExpanded: boolean;
  buttonLabel: string;
  onClick (e?: React.MouseEvent<HTMLButtonElement | HTMLAnchorElement, MouseEvent>): void;
}

const MenuButtonController: React.FC<IMenuControlProps> = ({ ariaExpanded, onClick, buttonLabel }) => (
  <MenuButtonStyles
    onClick={onClick}
    aria-controls='menu-control'
    aria-expanded={ariaExpanded}
    data-menubutton={true}
  >
    <ButtonLabel>{buttonLabel}</ButtonLabel>
    <MenuIcon icon='menu' />
  </MenuButtonStyles>
);

export default MenuButtonController;
